export const isSelected = (selected, id) => id in selected;
